import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { MicrophoneState } from '../../models/app/precall/microphone-state';
import { AudioInputDevice } from '../../models/app/precall/audio-input-device';

@Injectable({
  providedIn: 'root',
})
export class MicrophoneStore {
  private readonly _state = signal<MicrophoneState>({
    permissionGranted: false,
    streamActive: false,
  });

  private readonly _devices = signal<AudioInputDevice[]>([]);

  readonly state$: Observable<MicrophoneState> = toObservable(this._state);
  readonly devices$: Observable<AudioInputDevice[]> = toObservable(this._devices);

  updateState(state: Partial<MicrophoneState>): void {
    this._state.update((current) => ({ ...current, ...state }));
  }

  updateDevices(devices: AudioInputDevice[]): void {
    this._devices.set(devices);
  }

  get snapshot(): MicrophoneState {
    return this._state();
  }

  get devicesSnapshot(): AudioInputDevice[] {
    return this._devices();
  }
}
